export default {
  'cardBuilder.addCard': 'Add Card',
  'cardBuilder.cancelEdit': 'Cancel',
  'cardBuilder.editCard': 'Edit',
  'cardBuilder.removeCard': 'Remove',
  'cardBuilder.saveCard': 'Save',
  'cardBuilder.modal.title': 'Manage Your Options',
  'cardBuilder.modal.body': ' ',
};
